export { Component2 } from "./Component2";
